import { cn } from 'lib/helpers/utility';

import CounterSpan from './components/CounterSpan';
import { positionClasses, sizeClasses } from './lib/getClasses';

/** @param {import('./lib/propTypes').CounterProps} props */

const Counter = ({
  count,
  children,
  maxCount = 99,
  color = 'danger',
  shade = 500,
  className = '',
  size = 'medium',
  position = 'top-right'
}) => {
  const overflowCount = count > maxCount;

  return (
    <div className={cn('relative inline-flex items-center justify-center', className)}>
      {children}
      {count > 0 && (
        <div
          className={cn(
            'absolute flex items-center justify-center rounded-full px-1',
            `bg-${color}-${shade}`,
            sizeClasses[size],
            positionClasses[position]
          )}>
          <CounterSpan size={size}>{overflowCount ? maxCount : count}</CounterSpan>
          {overflowCount && (
            <CounterSpan size={size} className="mb-0.5">
              +
            </CounterSpan>
          )}
        </div>
      )}
    </div>
  );
};

export default Counter;
